/* eslint-disable  @typescript-eslint/no-explicit-any */
import { ELCLogger } from 'elc-logging';
import { Service } from 'elc-service';
import { ServiceBus } from 'elc-service-bus';
import { root } from 'elc-universal-utils';
import { startMark, endMark } from './perfMark';

export class ServiceLazyLoader {
    protected logger: ELCLogger = new ELCLogger('elc-ecomm-app');
    private appConfig: any = null;

    public load(appConfig = {}) {
        this.appConfig = appConfig;
        root.GlobalServiceBus.applyHook((serviceBus: ServiceBus<any, any, any, any, any>) => ({
            beforeEmit: this.beforeEmit,
            beforeQuery: this.beforeQuery
        }));
        const lazyLoadedServices = Object.keys(root.ServiceRegistry).filter(
            serviceName =>
                // @ts-ignore
                root.ServiceRegistry[serviceName].isLazy
        );
        root.ServiceRegistry = lazyLoadedServices.reduce((srvRegistry, srvName) => {
            const serv = root.ServiceRegistry[srvName];
            // For some reason elc-http-transport pulls in an older version of universal utils with wrong typings.
            srvRegistry[srvName] = {
                ...srvRegistry[srvName],
                // @ts-ignore
                getView: this.createLazyGetView(serv, appConfig)
            };

            return srvRegistry;
        }, root.ServiceRegistry);
    }
    private beforeEmit = async (action: string, payload: any, next: Function) => {
        startMark(`lazy_emit_${action}`);
        await this.maybeStartService(action, 'events');
        endMark(`lazy_emit_${action}`);

        next(action, payload);
    };
    private beforeQuery = async (queryName: string, payload: any, next: Function) => {
        startMark(`lazy_query_${queryName}`);
        await this.maybeStartService(queryName, 'queries');
        endMark(`lazy_query_${queryName}`);

        return next(queryName, payload);
    };
    private async maybeStartService(item: string, exposedItem: string) {
        const servicesToInitialize = Object.keys(root.ServiceRegistry).find(srvName => {
            const service: any = root.ServiceRegistry[srvName];

            return (
                service.isLazy && !service.isStarted && service[exposedItem].indexOf(item) !== -1
            );
        });
        if (servicesToInitialize) {
            const message = `Starting ${servicesToInitialize} service due to ${item} ${
                exposedItem === 'queries' ? 'query' : 'event'
            }!`;
            this.logger.info({
                message,
                triggerType: 'EcommApp.maybeStartService'
            });

            startMark(`lazy_initialize_${servicesToInitialize}`);
            await root.ServiceRegistry[servicesToInitialize].start(this.appConfig);
            endMark(`lazy_initialize_${servicesToInitialize}`);
        }
    }
    private createLazyGetView = (service: any, appConfig = {}) => (name: string) => {
        // when a view is requested, if it belongs to the service we need to
        // load it first
        let srv: Service | null = null;
        const serviceExposesView = service.views.indexOf(name) !== -1;
        if (serviceExposesView) {
            return {
                componentName: name,
                component: async () => {
                    this.logger.info({
                        message: `Starting service due to ${name} view being requested!`,
                        triggerType: 'EcommApp.createLazyGetView'
                    });
                    srv = await service.start(appConfig);
                    if (srv) {
                        const comp = srv.getView(name).component;

                        return (comp as any).load ? (comp as any).load() : undefined;
                    }
                },
                viewController: () => {
                    if (srv) {
                        return srv.getView(name).viewController;
                    }
                }
            };
        }

        return undefined;
    };
}
